import React, { useState } from "react";
import { connect } from "react-redux";
import { css } from "emotion";

import Button from "../../button/button";
import { formatPhone } from "../../../js/shared/utils";
import { boxInfoFinishedOfferStyle } from "./style";
import { useNewOffer } from "../../../js/context/new-offer";
import { setFidelityPhoneByFidelityId } from "../../../js/shared/requests-api";

import { MINIMAL_MILES_ADVANCED_AVERAGE } from "../../../../offers/js/shared/enums";

import { refreshOffers } from "../../../js/actions";

import ModalLatamPhone from "../ModalPhoneLatam/ModalLatamPhone";
import {GOL_ACRONYM, GOL_TWO_FACTOR_MESSAGE} from "../../../../js/shared/constants";

const BoxInfoFinishedOffer = ({ refreshOffers, typePhoneLatam }) => {
	const {
		currentProgram,
		editOffer: {forwardPayment, paymentDeadline, workingDays},
		offerData,
		loyaltyData,
		setLoyaltyData,
		phoneMultiplus
	} = useNewOffer();


	const { quant } = offerData?.data;
	const { phone, isMaxPhone, id } = loyaltyData.data;
	const phoneMMSuggestion = phoneMultiplus;

	const [showModalPhone, setShowModalPhone] = useState(false);

	const onChangePhone = phone => {
		let phoneMax = 0;
		setFidelityPhoneByFidelityId(id || 3, phone).then(() => {
			if (phoneMMSuggestion === phone) {
				phoneMax = 1;
			} else {
				phoneMax = 0;
			}
			setLoyaltyData({
				...loyaltyData,
				data: { ...loyaltyData.data, isMaxPhone: phoneMax, phone: phone }
			});

			refreshOffers();

			setShowModalPhone(false);
		});
	};

	const isLatam = () => {
		return currentProgram.id === 3 || currentProgram.id === 1;
	};

	const isSmiles = () => {
		return currentProgram.id === 4;
	}

	const isWrongLatamPhone = isLatam() && (isMaxPhone === 0 || isMaxPhone === -1);

	const getPeriod = () => {
		let period = `${paymentDeadline} ${paymentDeadline > 1 ? 'dias' : 'dia'}`;
		
		if(workingDays) 
			period = `${period} ${paymentDeadline > 1 ? 'úteis' : 'útil'}`;

		return period;
	}

	const isShowSmilesWarning = isSmiles() && (forwardPayment || quant < MINIMAL_MILES_ADVANCED_AVERAGE);

	return (
		<div
			className={css`
				${boxInfoFinishedOfferStyle}
			`}
		>
			<p className="title">Informações importantes</p>
			<ul className="list">
				{currentProgram?.acronym === GOL_ACRONYM ? <li>{GOL_TWO_FACTOR_MESSAGE}</li> : null}
				{isWrongLatamPhone && typePhoneLatam === 0 ? (
					<>
						<li>
							A cada emissão de passagem com suas milhas, a Latam envia um código SMS para o
							telefone celular cadastrado no programa
						</li>
						<li>
							As suas milhas <strong>não estarão disponíveis</strong> para venda até que o telefone{" "}
							<strong>{formatPhone(phoneMMSuggestion)}</strong> da MaxMilhas seja incluído no seu
							cadastro da Latam Pass.
						</li>
						<li>
							Após inserir o telefone indicado acima no Latam Pass,
							<Button
								onClick={() => {
									setShowModalPhone(true);
								}}
								className="link"
							>
								<strong>clique aqui</strong>
							</Button>
							e digite esse mesmo telefone para sabermos que o procedimento foi concluído.
						</li>
					</>
				) : (
					<>
						{isLatam() && typePhoneLatam === 0 ? (
							<li>
								Para que a sua oferta seja aprovada, o campo do telefone celular da sua conta Latam
								Pass deve ser preenchido com o mesmo número indicado no cadastro de oferta da
								MaxMilhas.
							</li>
						) : (
							<li>Você pode adicionar uma única oferta por programa de fidelidade.</li>
						)}
						{isShowSmilesWarning ? ( 
							<li>
								Se você for categoria Diamante, poderemos emitir passagens com redução de milhas na Tarifa Especial Diamante (teto) disponíveis em sua conta.
							</li>
						) 
						:
							null
						}
						{forwardPayment ? (
							<li>
								O pagamento pelas milhas será feito em {getPeriod()} a partir da aprovação da oferta.
								Vale lembrar que, depois de aprovada, a emissão de passagens com as milhas vendidas
								é feita de forma parcial, de acordo com a quantidade de milhas necessárias para o
								voo escolhido pelo passageiro. {`${!workingDays && `Caso o ${paymentDeadline}º dia seja um fim de semana ou feriado, 
								o pagamento será feito no dia útil seguinte.`}`}
							</li>
						) : (
							<>
								<li>
									O pagamento pelas suas milhas será feito em até <strong>{paymentDeadline || '60'} dias corridos</strong>,
									a partir da data de emissão da passagem. Caso o {paymentDeadline || '60'}º dia seja um fim de semana ou
									feriado, o pagamento será feito no dia útil seguinte.
								</li>
								<li>
									A venda de milhas da sua oferta é feita de forma parcial, de acordo com a
									quantidade de milhas necessárias para o voo escolhido pelo comprador.
								</li>
							</>
						)}
					</>
				)}
			</ul>
			<ModalLatamPhone
				show={showModalPhone}
				close={() => setShowModalPhone(false)}
				confirm={onChangePhone}
				phoneSugestion={phoneMMSuggestion}
				phone={phone}
				updateLatamPhone
			/>
		</div>
	);
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => {
	return {
		refreshOffers: () => dispatch(refreshOffers())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(BoxInfoFinishedOffer);
